import { render, staticRenderFns } from "./BolusCalculatorSettingTableV3.vue?vue&type=template&id=08682972&scoped=true"
import script from "./BolusCalculatorSettingTableV3.vue?vue&type=script&lang=js"
export * from "./BolusCalculatorSettingTableV3.vue?vue&type=script&lang=js"
import style0 from "./BolusCalculatorSettingTableV3.vue?vue&type=style&index=0&id=08682972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08682972",
  null
  
)

export default component.exports